import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {
  MatFormFieldModule, MatInputModule, MatSelectModule, MatAutocompleteModule, MatRadioModule,
  MatSlideToggleModule, MatButtonModule, MatCheckboxModule
} from '@angular/material';
import {FormularioDinamicoComponent} from './formulario-dinamico.component';
import {CampoDinamicoDirective} from './campo-dinamico/campo-dinamico.directive';
import {FormInputComponent} from './form-input/form-input.component';
import {FormSelectComponent} from './form-select/form-select.component';
import {FormButtonComponent} from './form-button/form-button.component';
import {FormTextareaComponent} from './form-textarea/form-textarea.component';
import {FormRadioButtonsComponent} from './form-radio-buttons/form-radio-buttons.component';
import {FormCheckboxesComponent} from './form-checkboxes/form-checkboxes.component';
import {FormSwitchComponent} from './form-switch/form-switch.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import { FormAutocompleteComponent } from './form-autocomplete/form-autocomplete.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonModule
  ],
  declarations: [
    FormularioDinamicoComponent, CampoDinamicoDirective,
    FormInputComponent, FormSelectComponent,
    FormTextareaComponent, FormRadioButtonsComponent, FormCheckboxesComponent,
    FormSwitchComponent, FormButtonComponent, FormAutocompleteComponent
  ],
  exports: [FormularioDinamicoComponent],
  schemas: [NO_ERRORS_SCHEMA],
  entryComponents: [
    FormInputComponent,
    FormTextareaComponent,
    FormSelectComponent,
    FormAutocompleteComponent,
    FormRadioButtonsComponent,
    FormCheckboxesComponent,
    FormButtonComponent,
    FormSwitchComponent
  ]
})
export class FormularioDinamicoModule {
}
